import * as datGui from 'dat.gui'
import { Color } from 'three'

export function addColorChangeGui(color: Color, targetFolder: datGui.GUI, name = 'Color') {
  const colorConf = { color: color.getHex() }
  targetFolder
    .addColor(colorConf, 'color')
    .name(name)
    .onChange((colorVal: number) => {
      color.setHex(colorVal)
    })
}
